var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDiamond(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 171.028,
    x2: 389.081,
    y1: 131.326,
    y2: 361.493
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4f7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a2e3e9"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a2e3e9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#518cd2"
  }))), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 235.359,
    x2: 281.51,
    xlinkHref: "#lg1",
    y1: 106.024,
    y2: 335.625
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 213.446,
    x2: 426.895,
    xlinkHref: "#lg1",
    y1: 243.586,
    y2: 347.426
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.725,
    x2: 493.791,
    xlinkHref: "#lg1",
    y1: 268.748,
    y2: 169.523
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.617,
    x2: 268.956,
    xlinkHref: "#lg1",
    y1: 258.553,
    y2: 462.633
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 322.204,
    x2: 398.353,
    xlinkHref: "#lg1",
    y1: 303.306,
    y2: 381.763
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 147.709,
    x2: 234.015,
    xlinkHref: "#lg1",
    y1: 132.233,
    y2: 174.22
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 331.201,
    x2: 154.673,
    xlinkHref: "#lg1",
    y1: 266.394,
    y2: 333.313
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 280.647,
    x2: 146.809,
    xlinkHref: "#lg1",
    y1: 191.342,
    y2: 43.659
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.342,
    x2: 85.11,
    xlinkHref: "#lg1",
    y1: 255.477,
    y2: 117.244
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 472.881,
    x2: 392.919,
    xlinkHref: "#lg1",
    y1: 252.27,
    y2: 172.308
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe548"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1758,
    stopColor: "#ffde50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4446,
    stopColor: "#ffca65"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7709,
    stopColor: "#ffaa87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff90a4"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 103.076,
    x2: 196.834,
    xlinkHref: "#lg2",
    y1: -15.068,
    y2: 102.764
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 92.92,
    x2: 139.799,
    xlinkHref: "#lg2",
    y1: 117.005,
    y2: 175.921
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 414.781,
    x2: 461.66,
    xlinkHref: "#lg2",
    y1: 241.086,
    y2: 300.002
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 14.176,
    x2: 61.055,
    xlinkHref: "#lg2",
    y1: 273.617,
    y2: 332.532
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 367.462,
    x2: 414.341,
    xlinkHref: "#lg2",
    y1: 138.802,
    y2: 197.718
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 496.06,
    x2: 496.266,
    xlinkHref: "#lg1",
    y1: 220.17,
    y2: 220.382
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m492.659 207.194-67.968-104.414c-3.312-5.088-8.589-8.573-14.569-9.62l-35.927-6.294c-76.885-13.469-155.526-13.469-232.41 0l-35.927 6.294c-5.98 1.048-11.257 4.532-14.569 9.62l-67.97 104.414c-5.164 7.933-4.644 18.287 1.288 25.663l216.323 268.971c8.763 10.896 25.355 10.896 34.118 0l216.323-268.972c5.932-7.376 6.452-17.729 1.288-25.662z",
    fill: "url(#SVGID_1_)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m492.659 207.195-67.969-104.416c-3.312-5.088-8.588-8.571-14.568-9.619l-35.928-6.294c-76.885-13.469-155.526-13.469-232.41 0l-35.928 6.294c-5.98 1.048-11.255 4.532-14.568 9.619l-67.969 104.416c-2.631 4.042-3.778 8.712-3.494 13.297h476.328c.285-4.585-.863-9.255-3.494-13.297z",
    fill: "url(#SVGID_2_)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m419.343 97.143c-2.702-1.998-5.84-3.391-9.22-3.984l-35.928-6.294c-76.885-13.469-155.526-13.469-232.41 0l-35.928 6.294c-3.379.592-6.517 1.985-9.22 3.984l8.183 123.349 145.948 288.281c4.667 1.622 9.778 1.622 14.445 0l145.947-288.281z",
    fill: "url(#SVGID_3_)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m104.819 220.492 145.948 288.281c4.667 1.622 9.778 1.622 14.445 0l145.948-288.281s-128.695-143.729-153.171-143.729c-24.475.001-153.17 143.729-153.17 143.729z",
    fill: "url(#SVGID_4_)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m104.814 220.487 145.949 288.275c-3.72-1.278-7.143-3.59-9.838-6.938l-216.322-268.969c-3.367-4.186-4.979-9.331-4.807-14.45-.023.694-.013 1.388.03 2.081h84.988z",
    fill: "url(#SVGID_5_)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m411.174 220.487-145.949 288.274c3.72-1.278 7.143-3.59 9.838-6.938l216.322-268.968c3.367-4.186 4.979-9.331 4.807-14.45.023.694.013 1.388-.03 2.081h-84.988z",
    fill: "url(#SVGID_6_)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m257.989 76.761c-24.472 0-153.175 143.726-153.175 143.726l-8.18-123.339c2.7-2.008 5.838-3.392 9.219-3.992l35.929-6.288c38.442-6.738 77.325-10.107 116.207-10.107z",
    fill: "url(#SVGID_7_)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m275.048 501.828 216.323-268.972c5.932-7.376 6.452-17.73 1.288-25.663l-67.968-104.413c-3.312-5.088-8.589-8.572-14.569-9.62l-35.927-6.294c-38.442-6.735-77.324-10.102-116.205-10.102v433.236c6.338 0 12.677-2.724 17.058-8.172z",
    fill: "url(#SVGID_8_)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m439.029 297.937-220.035-220.035c-.004 0-.009.001-.013.001-3.225.187-6.449.397-9.672.631-.002 0-.003 0-.005 0-6.354.46-12.703 1.012-19.045 1.652-.274.028-.548.057-.822.085-2.8.286-5.599.592-8.397.913-.402.046-.803.091-1.205.137-6.019.703-12.032 1.488-18.035 2.354-.714.103-1.428.21-2.142.316-2.262.334-4.523.679-6.783 1.037-.797.126-1.595.25-2.392.379-2.902.469-5.802.951-8.699 1.459l-8.159 1.429-5.153.903c1.997 1.804 3.939 3.668 5.856 5.557l-.254.045c1.321 1.193 2.616 2.413 3.901 3.643.613.639 1.214 1.29 1.817 1.938l-.117.021c.371.335.728.685 1.096 1.023 7.113 7.757 13.577 16.12 19.28 25.019l231.407 230.643z",
    fill: "url(#SVGID_9_)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m376.487 375.701-248.298-249.323c-1.572-2.452-5.21-2.452-6.781 0-6.989 10.906-16.228 20.234-27.063 27.323-2.405 1.573-2.405 5.162 0 6.735l252.682 251.895z",
    fill: "url(#SVGID_10_)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m489.448 235.252-29.975 37.279-49.612-49.451-40.971-40.844c-2.411-1.581-2.411-5.169 0-6.738 10.834-7.084 20.076-16.418 27.056-27.321 1.581-2.458 5.215-2.458 6.784 0l72.007 72.307z",
    fill: "url(#SVGID_11_)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m227.742 71.796c-21.67 14.178-40.148 32.835-54.128 54.647-3.144 4.905-10.419 4.905-13.563 0-13.979-21.812-32.456-40.468-54.127-54.647-4.81-3.147-4.81-10.323 0-13.47 21.671-14.178 40.148-32.835 54.127-54.647 3.143-4.905 10.419-4.905 13.563 0 13.979 21.812 32.457 40.469 54.128 54.647 4.81 3.147 4.81 10.322 0 13.47z",
    fill: "url(#SVGID_12_)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m155.253 160.437c-10.835 7.089-20.074 16.418-27.064 27.324-1.572 2.452-5.21 2.452-6.781 0-6.989-10.906-16.228-20.234-27.063-27.323-2.405-1.574-2.405-5.161 0-6.735 10.835-7.089 20.074-16.417 27.063-27.323 1.572-2.452 5.21-2.452 6.781 0 6.99 10.906 16.229 20.234 27.064 27.323 2.405 1.572 2.405 5.16 0 6.734z",
    fill: "url(#SVGID_13_)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m477.115 284.518c-10.835 7.089-20.074 16.418-27.064 27.324-1.572 2.452-5.21 2.452-6.781 0-6.989-10.906-16.228-20.234-27.063-27.323-2.405-1.574-2.405-5.161 0-6.735 10.835-7.089 20.074-16.418 27.063-27.323 1.572-2.452 5.21-2.452 6.781 0 6.99 10.906 16.229 20.234 27.064 27.323 2.405 1.572 2.405 5.16 0 6.734z",
    fill: "url(#SVGID_14_)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m76.509 317.048c-10.835 7.089-20.074 16.418-27.064 27.324-1.572 2.452-5.21 2.452-6.781 0-6.989-10.906-16.228-20.234-27.063-27.323-2.405-1.574-2.405-5.161 0-6.735 10.835-7.089 20.074-16.418 27.063-27.323 1.572-2.452 5.21-2.452 6.781 0 6.99 10.906 16.229 20.234 27.064 27.323 2.405 1.573 2.405 5.16 0 6.734z",
    fill: "url(#SVGID_15_)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m429.795 182.234c-10.835 7.089-20.074 16.418-27.064 27.324-1.572 2.452-5.21 2.452-6.781 0-6.989-10.906-16.228-20.234-27.063-27.323-2.405-1.574-2.405-5.161 0-6.735 10.835-7.089 20.074-16.417 27.063-27.323 1.572-2.452 5.21-2.452 6.781 0 6.99 10.906 16.229 20.234 27.064 27.323 2.405 1.572 2.405 5.16 0 6.734z",
    fill: "url(#SVGID_16_)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m496.175 220.068c0 .139 0 .277-.012.415h-.012c.012-.138.024-.276.024-.415z",
    fill: "url(#SVGID_17_)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDiamond);
export default __webpack_public_path__ + "static/media/icon-diamond.3ddfe5b222b6028fe7f878d2afd3b735.svg";
export { ForwardRef as ReactComponent };